import React, { useMemo, useEffect, useState, useRef, useCallback } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useNavigate, useLocation } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import { format } from 'date-fns';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Pagination from '@mui/material/Pagination';
import 'react-circular-progressbar/dist/styles.css';
import { Pie } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import LeadService from '../core/services/leadsService';
import toast from 'react-hot-toast';
import { debounce, throttle } from 'lodash';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Paper, Stack } from '@mui/material';
import BasicSelect from '../components/common/Select';
import Autocomplete from '@mui/material/Autocomplete';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { InputAdornment } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { CircularProgress, Container } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Tooltip from '@mui/material/Tooltip';
import logo_between from '../../public/assets/logo_between.png';
import Button from '@mui/material/Button';
import { ClassNames } from '@emotion/react';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import ScrollAnimation from 'react-animate-on-scroll';
import LogoutExpiredModal from '../components/LogoutExpiredModal';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import Agent from '../../public/statusImages/Agent.svg';
import AppointmentSet from '../../public/statusImages/AppointmentSet.svg';
import AttemptingContact from '../../public/statusImages/AttemptingContact.svg';
import BadLead from '../../public/statusImages/BadLead.svg';
import BamFam from '../../public/statusImages/BamFam.svg';
import Cancelled from '../../public/statusImages/Cancelled.svg';
import Closed from '../../public/statusImages/Closed.svg';
import MetWithCustomer from '../../public/statusImages/MetWithCustomer.svg';
import NotIntrested from '../../public/statusImages/NotIntrested.svg';
import NurtureBeforeSale from '../../public/statusImages/NurtureBeforeSale.svg';
import NurtureAfterSale from '../../public/statusImages/NurtureAfterSale.svg';
import PersonalLead from '../../public/statusImages/PersonalLead.svg';
import RefinanceReferral from '../../public/statusImages/RefinanceReferral.svg';
import Rejected from '../../public/statusImages/Rejected.svg';
import ShowingHomes from '../../public/statusImages/ShowingHomes.svg';
import SpokeWithCustomer from '../../public/statusImages/SpokeWithCustomer.svg';
import BuySideContract from '../../public/statusImages/BuySideContract.svg';
import New from '../../public/statusImages/New.svg';
import SubmittingOffers from '../../public/statusImages/SubmittingOffers.svg';
import UnderContract from '../../public/statusImages/UnderContract.svg';
import ListingUnderContract from '../../public/statusImages/ListUnderContract.svg';
import FollowUp from '../../public/statusImages/FollowUp.svg';
import ListingSigned from '../../public/statusImages/ListingSigned.svg';
// import Broker from '../../public/statusImages/BuyerBrokerSigned.svg';
import DNC from '../../public/statusImages/DNC.svg';
import BuyerBrokerSigned from '../../public/statusImages/BuyerBrokerSigned.svg';
import ValuationAppointment from '../../public/statusImages/ValuationAppointment.svg';
// import Assigned from '../../public/statusImages/Assigned.svg';
import ListingAppointment from '../../public/statusImages/ListingAppointment.svg';
import ListUnderContract from '../../public/statusImages/ListUnderContract.svg';
const useStyles = makeStyles((theme) => ({

    searchFilterPaper: {
        px: 1, py: 0.1, mb: 5,
        display: 'grid',
        justifyContent: 'center',
        width: 'auto',
        [theme.breakpoints.down('md')]: {
            width: '1050px',
            display: 'grid',
            justifyContent: 'center',
        },
        [theme.breakpoints.up('lg')]: {
            width: 'auto',
            display: 'grid',
            justifyContent: 'center',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1150px',
            display: 'grid',
            justifyContent: 'flex-start',
            // margin:'0 auto',
        },
    },
    ALLFilterPaper: {
        marginTop: '30px',
        display: 'flex',
        gap: '28px',
        justifyContent: 'center',
        marginRight: '180px',
        [theme.breakpoints.down('md')]: {
            width: '1050px',
            display: 'flex',
            justifyContent: 'center',
            marginRight: '0px',
        },
        [theme.breakpoints.up('md')]: {
            width: '1050px',
            display: 'flex',
            justifyContent: 'center',
            marginRight: '0px',
        },

    },
    searchFilterPaperDiv: {
        marginTop: '30px',
        display: 'flex',
        gap: '28px',
        justifyContent: 'center',
        // marginRight: '180px',
        [theme.breakpoints.down('md')]: {
            marginTop: '30px',
            display: 'flex',
            gap: '28px',
            justifyContent: 'center',
            marginRight: '-10px',

        },


    },
    AutoStyle: {
        width: 320,
        [theme.breakpoints.down('md')]: {
            width: 220

        },
    },
    AutocompletePaperStyle: {
        width: 'auto',
        [theme.breakpoints.down('md')]: {
            width: '1050px',
        },
        [theme.breakpoints.up('lg')]: {
            width: 'auto',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1150px',
        },
    },
    LeadTable: {
        overflowX: 'auto',
        width: '1310px',
        borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        [theme.breakpoints.down('md')]: {
            overflowX: 'auto',
            width: '1080px',
        },
        [theme.breakpoints.up('lg')]: {
            overflowX: 'auto',
            width: '1625px',
        },
        [theme.breakpoints.up('lg')]: {
            overflowX: 'auto',
            width: '1625px',
        },
        [theme.breakpoints.up('xl')]: {
            overflowX: 'auto',
            width: 'auto',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1150px',
        },
    },
    PaginationLeadTable: {
        marginTop: '-40px',
        zIndex: 1000,
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('md')]: {
            overflowX: 'auto',
            width: '1050px',
        },
    },
    LeadChartStyle: {
        width: '990px',
        height: '990px',
        marginTop: '20px',
        padding: '10px',
        [theme.breakpoints.down('md')]: {
            width: '590px',
            height: '990px',
            marginTop: '20px',
            padding: '10px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '490px',
            height: '990px',
            marginTop: '20px',
            padding: '10px',
        },

    }

}));
const AdminLeads = () => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const [chartDataPie, setChartDataPie] = useState(null);
    const [LeadData, setLeadData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [paiChartData, setPaiChartData] = useState();
    const [totalCountData, setTotalCountData] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [filtersData, setFilterData] = React.useState({});
    const [filterStatus, setFilterStatus] = React.useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [dateFilter, setdateFilter] = useState('');
    const [filters, setFilters] = useState({ source: '', lead_type: '', status: '' });
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = React.useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedSource, setSelectedSource] = useState(null);
    const [selectedLead, setSelectedLead] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);
    const [isCities, setIsCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [isDate, setIsDate] = React.useState(null);
    const [viewMode, setViewMode] = useState(location.state?.viewMode || 'list'); // 'list' or 'thumbnail'
    const [IsSearchType, setIsSearchType] = useState('');
    const [logOutModal, setLogOutModal] = React.useState(false);
    const chartRef = useRef(null);
    const abortControllerRef = useRef(null);
    const options = [];

    for (let i = 1; i <= 72; i++) {
        options.push({ label: `${i} Hours`, value: i });
    }

    const handleSetCurrentDate = () => {
        const now = dayjs();
        setFromDate(now);
    };

    const handleIsCurrentDate = () => {
        const now = dayjs();
        setIsDate(now);
    };

    const HandleChangeHours = (event, newValue) => {
        if (newValue) {
            setSelectedValue(newValue.value);
        }
    };

    const handleNavigateLeadDetails = (id) =>{
        navigate(`/admin-leads-details/${id}`,{ state: { viewMode } })
    }


    const StatusDisplayMap = {
        active: 'New',
        new: 'New',
        attempting_contact: 'Attempting Contact',
        spoke_with_customer_new: 'New',
        spoke_with_customer: 'Spoke with customer',
        appointment_set: 'Appointment Set',
        met_with_customer: 'Met with Customer',
        showing_homes: 'Showing Homes',
        submitting_offers: 'Submitting Offers',
        buy_side_contract: 'Buy Side Contract',
        under_contract_escrow: 'Under Contract',
        bamfam: 'BAMFAM',
        nurture: 'Nurture Before Sale',
        closed: 'Sale Closed',
        nurture_after_sale: 'Nurture After Sale',
        rejected: 'Rejected',
        not_interested: 'Not Interested',
        personal_lead: 'Personal Lead',
        refinance_referral: 'Refinance Referral',
        agent: 'Agent',
        bad_lead: 'Bad Lead',
        follow_up: 'Follow Up',
        buyer_broker_signed: 'Buyer Broker Signed',
        cancelled: 'Cancelled',
        valuation_appointment: 'Valuation Appointment',
        listing_appointment: 'Listing Appointment',
        listing_signed: 'Listing Signed',
        dnc: 'DNC',
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'Sr no',
                size: 40,
                showColumnFilters: false,
                enableColumnFilter: false,
                muiTableBodyCellProps: {
                    align: 'left',
                },
            },
            {
                accessorFn: (row) => {
                    return row?.last_name === null
                        ? row?.first_name
                        : `${row?.first_name} ${row?.last_name}`;
                },
                header: 'Lead Name',
                enableColumnActions: false,
                showColumnFilters: false,
                enableColumnFilter: false,
                enableSorting: false,
                size: 150,
                muiTableHeadCellProps: {
                    align: 'left',
                },
                Cell: ({ row }) => (
                    <span
                    onClick={ () => handleNavigateLeadDetails(row.original.id)}
                        style={{ cursor: 'pointer', fontWeight: '500' }} // optional styling
                    >
                        {row?.original.last_name === null
                            ? row?.original.first_name
                            : `${row?.original.first_name} ${row?.original.last_name}`}
                    </span>
                ),
                muiTableBodyCellProps: {
                    sx: {
                        fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                    },
                },
            },

            {
                accessorKey: 'email',
                header: 'Email',
                size: 100,
                // enableClickToCopy: true,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'phone',
                header: 'Phone Number',
                size: 50,
                enableSorting: false,
                showColumnFilters: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'status',
                enableSorting: false,
                header: 'Status',
                Cell: ({ cell }) => StatusDisplayMap[cell.getValue()] || cell.getValue(),
                size: 100,
                // filterSelectOptions:
                // filterVariant: 'select',
            },
            {
                accessorFn: (row) => {
                    const assignUserLead = row?.assign_user_leads?.[0];
                    const assignto = assignUserLead?.assignto;
                    if (!assignto) {
                        return '';
                    }
                    return assignto.last_name ? `${assignto.name} ${assignto.last_name}` : assignto.name;
                },
                header: 'Assign To',
                enableColumnActions: false,
                showColumnFilters: false,
                enableColumnFilter: false,
                enableSorting: false,
                size: 50,
                muiTableHeadCellProps: {
                    align: 'left',
                },
            },
            {
                accessorFn: (row) => {
                    const assignUserLead = row?.assign_user_leads?.[0];
                    const assignby = assignUserLead?.assignby;
                    if (!assignby) {
                        return '';
                    }
                    return assignby.last_name ? `${assignby?.name} ${assignby?.last_name}` : assignby.last_name;
                },
                header: 'Assign By',
                enableColumnActions: false,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
                size: 50,
                muiTableHeadCellProps: {
                    align: 'left',
                },
            },
            {
                accessorKey: 'assign_user_leads',
                header: 'Assign Date ',
                enableColumnActions: false,
                showColumnFilters: false,
                enableColumnFilter: false,
                enableSorting: true,
                size: 50,
                muiTableHeadCellProps: {
                    sx: {
                        // fontSize: '12px',
                    },
                },
                accessorFn: (row) => {

                    if (row?.assign_user_leads?.[0]?.updated_at && row?.assign === "2") {
                        const updatedAt = row?.assign_user_leads?.[0]?.updated_at;
                        const dateTime = new Date(updatedAt);
                        const userOffset = getUserOffset();
                        const adjustedDateTime = adjustTimeOffSetAssignedAtForReceived(dateTime, userOffset);
                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                    }
                    return '';
                },
                // Cell: ({ row }) => {
                //     const updatedAt = row?.original?.assign_user_leads?.[0]?.updated_at;
                //     return <span>{updatedAt ? format(new Date(updatedAt), 'MMMM dd, yyyy') : null}</span>;
                // },
            },
            {
                accessorFn: (row) => {
                    if (row?.date && row?.time) {
                        const dateTimeString = `${row.date} ${row.time}`;
                        const dateTime = new Date(dateTimeString);
                        const userOffset = getUserOffset();
                        const adjustedDateTime = adjustTimeBasedOnOffsetForReceivedData(dateTime, userOffset);
                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                    }
                    return '';
                },
                header: 'Appt Date/Time',
                size: 50,
                showColumnFilters: false,
                enableColumnFilter: false,
            },
            {
                // accessorKey: 'created_at',
                header: 'Created at',
                size: 100,
                showColumnFilters: false,
                enableSorting: true,
                enableColumnFilter: false,
                accessorFn: (row) => {
                    if (row?.created_at) {
                        const updatedAt = row?.created_at;
                        const dateTime = new Date(updatedAt);
                        const userOffset = getUserOffset();
                        const adjustedDateTime = adjustTimeOffSetAssignedAtForReceived(dateTime, userOffset);
                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                    }
                    return '';
                },
            },

            {
                accessorKey: 'source',
                header: 'Source',
                size: 100,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'lead_type',
                header: 'Lead Type',
                size: 100,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
            },

            {
                id: 'actions',
                enableSorting: false,
                accessorFn: (row) => row.id,
                showColumnFilters: false,
                enableColumnFilter: false,
                header: 'See More',
                size: 100,
                Cell: ({ row }) => (
                    <div style={{ display: 'flex', marginLeft: '20px' }}>
                        <IconButton aria-label="view" 
                        onClick={ () => handleNavigateLeadDetails(row.original.id)}
                        >
                            <VisibilityIcon />
                        </IconButton>
                    </div>
                ),
            },
        ],
        [navigate]
    );
    // pie chart
    let backgroundColors = {
        'Agent': '#121212',
        'Appointment Set': '#00BF2A',
        'Attempting Contact': '#7400C2',
        'Bad Lead': '#ED7DB1',
        'BAMFAM': '#6EA478',
        'Cancelled': '#4C489B',
        'Closed': '#6691CB',
        'Met with customer': '#0E4B37',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#DA5151',
        'Personal Lead': '#FEFE00',
        'Refinance Referral': '#008E6C',
        'Rejected': '#7C0083',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000FE',
        'Buy Side Contract': '#FE4C00',
        'New': '#FFC107',
        'Submitting Offers': '#00FE00',
        'Under Contract': '#AAFFC3',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990',
        'Listing Signed': '#C29800',
        'Broker': '#FF0058',
        'DNC': '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        'Assigned': '#00FBFE',
        'Listing Appointment': '#CB5935',
    };
    let circleProgressColors = {
        'Agent': '#121212',
        'Appointment Set': '#00bf2aa1',
        'Attempting Contact': '#7400c2a8',
        'Bad Lead': '#ed7db18a',
        'BAMFAM': '#6ea478b8',
        Cancelled: '#4c489bb0',
        'Closed': '#6691cbcf',
        'Met with customer': '#0e4b37d1',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#da5151d9',
        'Personal Lead': '#fefe009e',
        'Refinance Referral': '#008e6cb5',
        'Rejected': '#7c0083b0',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000fe85',
        'Buy Side Contract': '#fe4c00ad',
        'New': '#ffc107bd',
        'Submitting Offers': '#53eb53d6',
        'Under Contract': '#AAFFC3',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990d6',
        'Listing Signed': '#c29800c2',
        'Broker': '#FF0058',
        'DNC': '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        'Assigned': '#00FBFE',
        'Listing Appointment': '#cb5935c9',
    };
    let statusLabelColors = {
        'Agent': '#121212',
        'Appointment Set': '#00bf2aa1',
        'Attempting Contact': '#7400c2a8',
        'Bad Lead': '#ed7db18a',
        'BAMFAM': '#6ea478b8',
        Cancelled: '#4c489bb0',
        Closed: '#6691cbcf',
        'Met with customer': '#0e4b37d1',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#da5151d9',
        'Personal Lead': '#c3c331',
        'Refinance Referral': '#008e6cb5',
        Rejected: '#7c0083b0',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000fe85',
        'Buy Side Contract': '#fe4c00ad',
        New: '#ffc107bd',
        'Submitting Offers': '#53eb53d6',
        'Under Contract': '#6fdb8f',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990d6',
        'Listing Signed': '#c29800c2',
        Broker: '#FF0058',
        DNC: '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        Assigned: '#00FBFE',
        'Listing Appointment': '#cb5935c9',
    }
    const statusImages = {
        Agent: Agent,
        'Appointment Set': AppointmentSet,
        'Attempting Contact': AttemptingContact,
        'Bad Lead': BadLead,
        BAMFAM: BamFam,
        Cancelled: Cancelled,
        Closed: Closed,
        'Met with customer': MetWithCustomer,
        'Not Interested': NotIntrested,
        'Nurture Before Sale': NurtureBeforeSale,
        'Nurture After Sale': NurtureAfterSale,
        'Personal Lead': PersonalLead,
        'Refinance Referral': RefinanceReferral,
        Rejected: Rejected,
        'Showing Homes': ShowingHomes,
        'Spoke with Customer': SpokeWithCustomer,
        'Buy Side Contract': BuySideContract,
        New: New,
        'Submitting Offers': SubmittingOffers,
        'Under Contract': UnderContract,
        'Listing Under Contract': ListingUnderContract,
        'Follow Up': FollowUp,
        'Listing Signed': ListingSigned,
        // Broker: Broker,
        DNC: DNC,
        'Buyer Broker Signed': BuyerBrokerSigned,
        'Valuation Appointment': ValuationAppointment,
        // Assigned: Assigned,
        'Listing Appointment': ListingAppointment,
        'List Under Contract': ListUnderContract,
    };
    let backgroundColorsCard = {
        'Agent': '#3e3e3e3d',
        'Appointment Set': '#23f95269',
        'Attempting Contact': '#6204a142',
        'Bad Lead': '#fd60a94a',
        'BAMFAM': '#6ea47869',
        'Cancelled': '#4c489b36',
        'Closed': '#6691cb45',
        'Met with customer': '#0e4b3770',
        'Not Interested': '#feb06569',
        'Nurture Before Sale': '#9b5b5b4d',
        'Nurture After Sale': '#da51515e',
        'Personal Lead': '#d9d9155c',
        'Refinance Referral': '#008e6c82',
        'Rejected': '#7c008352',
        'Showing  Homes': '#f032e657',
        'Spoke with Customer': '#0000fe45',
        'Buy Side Contract': '#fe4c0063',
        'New': '#c59a1870',
        'Submitting Offers': '#00fe0047',
        'Under Contract': '#256c398f',
        'Listing Under Contract': '#8d828226',
        'Follow Up': '#46999042',
        'Listing Signed': '#c298004f',
        'Broker': '#c59a1870',
        'DNC': '#a87bff4d',
        'Buyer Broker Signed': '#f786b047',
        'Valuation Apointment': '#7d9b0075',
        'Assigned': '#00FBFE',
        'Listing Appointment': '#cb593557',
        'List Under Contract': '#5c2e2e9c',

    };
    const percentages = paiChartData?.map((lead) => {
        const percentage = (lead.status_count / totalCountData) * 100;
        const formattedPercentage = percentage.toFixed(2);
        return formattedPercentage;
    });

    useEffect(() => {
        const labels = paiChartData?.map((lead) => lead.status);
        const chartData = paiChartData?.map((lead) => lead.status_count);
        const backgroundColor = labels?.map((label) => backgroundColors[label]);
        const initialData = {
            labels: labels,
            datasets: [
                {
                    data: chartData,
                    backgroundColor: backgroundColor,
                    borderColor: 'white',
                    // borderRadius: 1,
                    borderWidth: 1,
                },
            ],
        };

        setChartDataPie(initialData);
    }, [paiChartData]);

    useEffect(() => {
        if (chartDataPie && chartRef.current) {
            Chart.defaults.font.size = 12;
            Chart.defaults.font.weight = 'bold';
            const myChart = new Chart(chartRef.current, {
                type: 'pie',
                data: chartDataPie,
                options: {
                    plugins: {
                        legend: {
                            display: false,
                        },
                        title: {
                            display: true,
                            text: 'Status  Overview',
                            position: 'top',
                            align: 'start',
                            font: {
                                size: 20,
                                weight: 'bold',
                            },
                            padding: 20,
                        },
                        datalabels: {
                            color: 'black',
                            anchor: 'end',
                            align: 'end',
                            formatter: (value, context) => value,
                            font: {
                                weight: 'bold',
                                size: 12,
                            },
                        },
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                var label = context.dataset.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += context.parsed.y;
                                }
                                return label;
                            },
                        },
                        bodyFontColor: function (context) {
                            var dataset = context.dataset;
                            var index = context.dataIndex;
                            var value = dataset.data[index];
                            return dataset.backgroundColor[index];
                        },
                    },
                    layout: {
                        padding: {
                            left: 30,
                            right: 30,
                            top: 10,
                            bottom: 10,
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                },
            });

            return () => {
                myChart.destroy();
            };
        }
    }, [chartDataPie]);

    const GetAllCities = async () => {
        try {
            const res = await LeadService.AllCities();
            if (res?.data?.success) {
                setIsCities(res?.data?.data);
            }
        } catch (error) {
            toast.error(error.message || 'An error occurred');
            console.error(error);
        }
    };

    const GetAllLeads = async (

        currentPage,
        searchTerm = '',
        filters = { source: '', lead_type: '', status: '' },
        searchParam = { from_date: '', to_date: '', search_type: '' },
        IsSearchType = '',
        signal

    ) => {
        try {
            setLoading(true);
            const res = await LeadService.AllLeadByAdmin(currentPage, searchTerm, filters, searchParam, IsSearchType, { signal });
            if (res?.data?.success) {
                setLeadData(res?.data?.leads?.data || []);
                setCurrentPage(res?.data?.leads?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.leads?.total || 0) / (res?.data?.leads?.per_page || 1)));
            } else {
                toast.error('Failed to fetch leads');
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };
    const throttledGetLeads = useCallback(
        throttle((page, searchTerm, filters, dateFilter, IsSearchType, signal) => {
            GetAllLeads(page, searchTerm, filters, dateFilter, IsSearchType, signal);
        }, 2000),
        []
    );

    const fetchLeads = useCallback(
        debounce((page, searchTerm, filters, dateFilter, IsSearchType) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetLeads(page, searchTerm, filters, dateFilter, IsSearchType, abortController.signal);
        }, 300),
        [throttledGetLeads]
    );
    useEffect(() => {
        fetchLeads(currentPage, searchTerm, filters, dateFilter, IsSearchType);
    }, [currentPage, searchTerm, filters, dateFilter, fetchLeads]);

    const handleSearchChange = (event) => {
        const newSearchValue = event.target.value;
        setSearchTerm(newSearchValue);
        if (newSearchValue !== null) {
            localStorage.setItem('searchTerm', JSON.stringify(newSearchValue));
        } else {
            localStorage.removeItem('searchTerm');
        }
        setCurrentPage(1);

    };

    const handleClear = async () => {
        setCurrentPage(1);
        setSearchTerm('');
        await GetAllLeads(1, searchTerm, filters, dateFilter);
    };


    const adjustTimeBasedOnOffsetForSendData = (date, offsetInHours) => {

        const dateObj = new Date(date);
        const utcDate = new Date(dateObj.toUTCString()); // Convert to UTC
        if (offsetInHours > 0) {
            utcDate.setHours(utcDate.getHours() - offsetInHours);
        } else {
            utcDate.setHours(utcDate.getHours() - offsetInHours);
        }
        return utcDate;
    };

    const adjustTimeBasedOnOffsetForReceivedData = (date, offsetInHours) => {
        const adjustedDate = new Date(date);
        adjustedDate.setHours(adjustedDate.getHours() + offsetInHours);
        return adjustedDate;
    };

    const adjustTimeOffSetAssignedAtForReceived = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const formatDateTimeIn12HourFormat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM/PM
        hours = String(hours).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };


    const formatDate = (date) => {
        return date ? dayjs(date).format('DD-MM-YYYY HH:mm:ss') : null;
    };

    const handleSearchClick = async (searchTerm, filters, searchType) => {

        const currentDate = new Date();
        const formattedCurrentDate = formatDate(currentDate);

        if (!fromDate) {
            if (!toDate) {
                toast.error('Please select the to date.');
                return;
            }
        }

        if (fromDate === "") {
            return toast.error('please select the from data');
        } else if (toDate === "") {
            return toast.error('please select the to date');
        }

        if (toDate && fromDate && toDate.isBefore(fromDate)) {
            toast.error('Please select a to date later than the start date.');
            return;
        }

        const userOffset = getUserOffset();
        const formattedFromDate = formatDate(adjustTimeBasedOnOffsetForSendData(fromDate, userOffset));
        const formattedToDate = formatDate(adjustTimeBasedOnOffsetForSendData(toDate, userOffset));

        setIsSearchType('');
        const searchParam = {
            from_date: formattedFromDate,
            to_date: formattedToDate,
            current_date: formattedCurrentDate,
            search_type: searchType
        };


        // Store from_date and to_date in local storage
        const SaveFilterDate = {
            from_date: formattedFromDate,
            to_date: formattedToDate,
            search_type: searchType
        };

        localStorage.setItem('SaveFilterDate', JSON.stringify(SaveFilterDate));
        if (fromDate !== null) {
            localStorage.setItem('fromDate', JSON.stringify(fromDate));
        }
        if (toDate !== null) {
            localStorage.setItem('toDate', JSON.stringify(toDate));
        }
        if (searchType !== null) {
            localStorage.setItem('searchType', JSON.stringify(searchType));
        }


        setdateFilter(searchParam);
        // await GetAllLeads(1, searchTerm, filters, searchParam); // In future we should remove this function
    };


    const clearALLState = (filters, dateFilter) => {
        localStorage.removeItem('selectedStatus');
        localStorage.removeItem('selectedSource');
        localStorage.removeItem('selectedLead');
        localStorage.removeItem('SaveFilterDate');
        localStorage.removeItem('filters');
        localStorage.removeItem('fromDate');
        localStorage.removeItem('toDate');
        localStorage.removeItem('searchType');
        localStorage.removeItem('searchTerm');
        setFromDate('');
        setToDate('');
        setCurrentPage(1);
        setdateFilter('');
        setSearchTerm('');
        setFilters({ source: '', lead_type: '', status: '' });
        setSelectedStatus(null);
        setSelectedSource(null);
        setSelectedLead(null);
        fetchLeads(1, '', filters, dateFilter);
    };

    const getPaiChartLeadStatus = async () => {
        try {
            setLoading(true);
            const res = await LeadService.GetLeadsCountByStatus();
            if (res?.data?.success) {
                setPaiChartData(res?.data?.leadsCount);
                setTotalCountData(res?.data?.totalLeadsCount);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleFilters = (value, name) => {
        setFilters((prev) => {
            const selectedValue = value === 'all' ? '' : value ? value.value : ''; // Use the original value for backend
            return {
                ...prev,
                [name]: selectedValue,
            };
        });
    };

    const transformText = (text) => {
        return text
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // Function to handle transformations for all arrays
    const transformData = (data) => {
        return data?.map((item) => ({
            value: item,
            text: transformText(item),
        }));
    };

    const getLeadSearchData = async () => {
        try {
            const res = await LeadService.getLeadSearchDataApi();
            if (res?.data?.success) {
                const transformedStatuses = transformData(res.data.status);
                // const transformedSources = res.data.sources.map(source => ({      // Access all data in array
                //     value: source,
                //     text: source.replace(/\\/g, ''),
                // }));
                const transformedSources =
                    res.data.sources.length > 0
                        ? [
                            {
                                // Access only the first element of the sources array
                                value: res.data.sources[0],
                                text: res.data.sources[0].replace(/\\/g, ''),
                            },
                        ]
                        : [];
                const transformedLeadTypes = transformData(res.data.lead_type);
                setFilterData({
                    ...res.data,
                    status: transformedStatuses,
                    sources: transformedSources,
                    lead_type: transformedLeadTypes,
                });
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        GetAllCities();
        getPaiChartLeadStatus();
        getLeadSearchData();
    }, []);



    const csvConfig = mkConfig({
        fieldSeparator: ',',
        decimalSeparator: '.',
        useKeysAsHeaders: true,
    });
    const handleExportRows = (rows) => {
        const rowData = rows?.map((row) => {
            const rowDataObj = {};
            columns.forEach((col) => {
                if (col.header === 'See More') {
                    // rowDataObj[col.header] = '';
                    return;
                } else if (col.header === 'User Name') {
                    const userName = col.accessorFn ? col.accessorFn(row) : '';
                    rowDataObj[col.header] = userName;
                } else {
                    rowDataObj[col.accessorKey] = row[col.accessorKey];
                }
            });
            return rowDataObj;
        });
        const csv = generateCsv(csvConfig)(rowData);
        download(csvConfig)(csv);
    };

    const handleNavigateSchedule = () => {
        const userOffset = getUserOffset();
        const isDateFormate = formatDate(adjustTimeBasedOnOffsetForSendData(isDate, userOffset));
        const UserType = 'lead';
        navigate(`/ViewAllJobRoutes`, {
            state: {
                UserType: UserType,
                selectedValueHoursRoutes: selectedValue,
                isDateFormate: isDateFormate,
                selectedCityRoutes: selectedCity,
            },
        });
    };

    useEffect(() => {
        // For HOURS  (All Jobs Routes)
        if (selectedValue !== null) {
            localStorage.setItem('selectedValue', JSON.stringify(selectedValue));
        }

        if (isDate !== null) {
            localStorage.setItem('isDate', JSON.stringify(isDate)); // Store as ISO string
        }
        if (selectedCity !== null) {
            localStorage.setItem('selectedCity', JSON.stringify(selectedCity));
        }

        // Lead Search

        if (selectedStatus !== null) {
            localStorage.setItem('selectedStatus', JSON.stringify(selectedStatus));
        }

        if (selectedSource !== null) {
            localStorage.setItem('selectedSource', JSON.stringify(selectedSource));
        }
        if (selectedLead !== null) {
            localStorage.setItem('selectedLead', JSON.stringify(selectedLead));
        }

        // Store filters in localStorage
        if (selectedSource !== null || selectedLead !== null || selectedStatus !== null) {
            const filters = {
                source: selectedSource?.value,
                lead_type: selectedLead?.value,
                status: selectedStatus?.value
            };
            localStorage.setItem('filters', JSON.stringify(filters));
        }



    }, [selectedValue, isDate, selectedCity, selectedStatus, selectedSource, selectedLead]);

    useEffect(() => {
        const savedValue = localStorage.getItem('selectedValue');
        if (savedValue) {
            setSelectedValue(JSON.parse(savedValue));
        }

        const savedDate = localStorage.getItem('isDate');
        if (savedDate) {
            setIsDate(dayjs(JSON.parse(savedDate)));
        }

        const savedCity = localStorage.getItem('selectedCity');
        if (savedCity) {
            setSelectedCity(JSON.parse(savedCity));
        }

        // Lead Search

        const statusSaved = localStorage.getItem('selectedStatus');
        if (statusSaved) {
            setSelectedStatus(JSON.parse(statusSaved));
        }

        const sourceSaved = localStorage.getItem('selectedSource');
        if (sourceSaved) {
            setSelectedSource(JSON.parse(sourceSaved));
        }

        const leadSaved = localStorage.getItem('selectedLead');
        if (leadSaved) {
            setSelectedLead(JSON.parse(leadSaved));
        }

        const savedFilterDate = localStorage.getItem('SaveFilterDate');
        if (savedFilterDate) {
            const { from_date, to_date, searchType } = JSON.parse(savedFilterDate);
            setdateFilter({ from_date, to_date, searchType });
            // setFromDate(from_date ? dayjs(from_date) : null);
            // setToDate(to_date ? dayjs(to_date) : null);

        }
        const SaveFromDate = localStorage.getItem('fromDate');
        if (SaveFromDate) {
            setFromDate(dayjs(JSON.parse(SaveFromDate)));
        }
        const SaveToDate = localStorage.getItem('toDate');
        if (SaveToDate) {
            setToDate(dayjs(JSON.parse(SaveToDate)));
        }

        const saveSearchType = localStorage.getItem('searchType');
        if (saveSearchType) {
            setIsSearchType(JSON.parse(saveSearchType));
        }


        const savedFilters = localStorage.getItem('filters');
        if (savedFilters) {
            const { source, lead_type, status } = JSON.parse(savedFilters);
            setFilters({ source, lead_type, status });
        }

        const savedSearchTerm = localStorage.getItem('searchTerm');
        if (savedSearchTerm) {
            setSearchTerm(JSON.parse(savedSearchTerm));
        }

    }, []);


    const HandleClearLocalStorageCityDate = () => {
        localStorage.removeItem('selectedCity');
        localStorage.removeItem('isDate');
        localStorage.removeItem('selectedValue');
        localStorage.removeItem('searchTerm');
        setSelectedCity(null);
        setIsDate(null);
        setSelectedValue(null);
        setSearchTerm('');

    }

    return (
        <>
            <ScrollAnimation animateIn='fadeIn'>
                <div >
                    <Paper className={classes.searchFilterPaper} sx={{ px: 1, py: 0.1, mb: 5, borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', }}>
                        <span style={{ fontSize: '26px', fontWeight: 'bold', padding: '12px' }}>Search Filters</span>
                        <Box className={classes.ALLFilterPaper}>
                            <Autocomplete
                                value={selectedStatus || null} // Control the Autocomplete value
                                onChange={(event, value) => {
                                    if (!value) {
                                        setSelectedStatus(null);
                                        setCurrentPage(1);
                                        // GetAllLeads();
                                        setFilters((prevFilters) => ({ ...prevFilters, status: '' }));
                                    } else {
                                        setSelectedStatus(value);
                                        handleFilters(value, 'status');
                                    }
                                }}
                                options={filtersData.status || []}
                                getOptionLabel={(option) => option.text}
                                renderInput={(params) => <TextField {...params} label="Status" />}
                                sx={{
                                    width: 305, '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                                disabled={loading}
                            />
                            <Autocomplete
                                // onChange={(event, value) => handleFilters(value, 'source')}
                                value={selectedSource || null}
                                onChange={(event, value) => {
                                    if (!value) {
                                        setSelectedSource(null);
                                        setCurrentPage(1);
                                        // GetAllLeads();
                                        setFilters((prevFilters) => ({ ...prevFilters, source: '' }));
                                    } else {
                                        setSelectedSource(value);
                                        handleFilters(value, 'source');
                                    }
                                }}
                                options={filtersData.sources || []}
                                getOptionLabel={(option) => option.text}
                                renderInput={(params) => <TextField {...params} label="Source" />}
                                sx={{
                                    width: 305, '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                                disabled={loading}
                            />
                            <Autocomplete
                                // onChange={(event, value) => handleFilters(value, 'lead_type')}
                                value={selectedLead || null}
                                onChange={(event, value) => {
                                    if (!value) {
                                        setSelectedLead(null);
                                        setCurrentPage(1);
                                        // GetAllLeads();
                                        setFilters((prevFilters) => ({ ...prevFilters, lead_type: '' }));
                                    } else {
                                        setSelectedLead(value);
                                        handleFilters(value, 'lead_type');
                                    }
                                }}
                                options={filtersData.lead_type || []}
                                getOptionLabel={(option) => option.text}
                                renderInput={(params) => <TextField {...params} label="Lead Type" />}
                                sx={{
                                    width: 305, '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                                disabled={loading}
                            />

                            {/* <Button
                                disabled={LeadData.length === 0}
                                onClick={() => handleExportRows(LeadData)}
                                startIcon={<FileDownloadIcon />}
                            >
                                Export Page Rows
                            </Button> */}
                        </Box>
                        <Box
                            className={classes.searchFilterPaperDiv}
                        >
                            <Box>
                                <div style={{ display: 'flex', justifyContent: 'space-between', }}>
                                    <div>
                                        <Typography sx={{ fontWeight: 'bold' }}>From</Typography>
                                    </div>
                                    <div>
                                        <Button
                                            onClick={handleSetCurrentDate}
                                            sx={{
                                                borderRadius: '8px',
                                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                width: 'auto',
                                                cursor: 'pointer',
                                                fontWeight: 'bold',
                                                fontSize: '8px',

                                            }}
                                            variant="outlined"
                                        >
                                            Today
                                        </Button>
                                    </div>
                                </div>
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker
                                                sx={{
                                                    width: '320px',
                                                    overflow: 'hidden',
                                                    '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#c1c1c1',
                                                    },
                                                    '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#c1c1c1',
                                                    }, '& .MuiOutlinedInput-root': {
                                                        borderRadius: '12px',
                                                    },
                                                }}
                                                value={fromDate}
                                                onChange={(newDate) => setFromDate(newDate)}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                            </Box>

                            <Box>
                                <div>
                                    <Typography sx={{ fontWeight: 'bold' }}>To</Typography>
                                </div>
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker
                                                sx={{
                                                    width: '320px',
                                                    overflow: 'hidden',
                                                    '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#c1c1c1',
                                                    },
                                                    '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#c1c1c1',
                                                    }, '& .MuiOutlinedInput-root': {
                                                        borderRadius: '12px',
                                                    },
                                                }}
                                                value={toDate}
                                                onChange={(newDate) => setToDate(newDate)}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                            </Box>

                            <Box style={{ marginTop: '30px' }}>
                                <TextField
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    placeholder="Search by name , email"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleClear} aria-label="clear search">
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    sx={{
                                        width: '276px', '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </Box>


                        </Box>
                        <div style={{ marginTop: '25px', display: 'flex', marginBottom: '25px', gap: '12px', justifyContent: 'center' }}>
                            {selectedStatus?.value === "appointment_set" || selectedStatus?.value === "bamfam" ? (

                                <>

                                    <Button
                                        variant="contained"
                                        sx={{
                                            cursor: 'pointer',
                                            borderRadius: '12px',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            fontWeight: 'bold',
                                            height: '40px',
                                            marginTop: '6px',
                                            background: "#5379BD",
                                            fontFamily: 'inherit',
                                        }}
                                        onClick={() => handleSearchClick(searchTerm, filters, 'created')}
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        style={{
                                            width: '30px',
                                            height: '39px',
                                            border: '1px solid gray',
                                            background: '#bababa',
                                            borderRadius: '12px',
                                            fontWeight: 'bold',
                                            marginLeft: '0px',
                                            cursor: 'pointer',
                                            marginTop: '6px',
                                            color: 'black',
                                        }}
                                        sx={{ fontFamily: 'inherit', }}
                                        onClick={() => clearALLState(searchTerm)}
                                    >
                                        Clear
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button
                                        sx={{
                                            cursor: 'pointer',
                                            borderRadius: '12px',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            fontWeight: 'bold',
                                            height: '40px',
                                            marginTop: '6px',
                                            background: "#5379BD",
                                            fontFamily: 'inherit',
                                        }}
                                        variant="contained"
                                        onClick={() => handleSearchClick(searchTerm, filters, 'created')}
                                    > Search By Created At
                                        {/* {loading ? (
                                    <CircularProgress sx={{ color: 'white',}} />
                                ) : (
                                    <SearchIcon
                                        style={{
                                            color: 'white',
                                            margin: '12px',
                                            fontSize: '21px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )} */}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            cursor: 'pointer',
                                            borderRadius: '12px',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            fontWeight: 'bold',
                                            height: '40px',
                                            marginTop: '6px',
                                            background: "#5379BD",
                                            fontFamily: 'inherit',
                                        }}

                                        onClick={() => handleSearchClick(searchTerm, filters, 'assign')}
                                    > Search By Assigned At
                                        {/* {loading ? (
                                    <CircularProgress sx={{ color: 'white',}} />
                                ) : (
                                    <SearchIcon
                                        style={{
                                            color: 'white',
                                            margin: '12px',
                                            fontSize: '21px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )} */}
                                    </Button>
                                    <Button
                                        style={{
                                            width: '30px',
                                            height: '39px',
                                            border: '1px solid gray',
                                            background: '#bababa',
                                            borderRadius: '12px',
                                            fontWeight: 'bold',
                                            marginLeft: '0px',
                                            cursor: 'pointer',
                                            marginTop: '6px',
                                            color: 'black',
                                        }}
                                        sx={{ fontFamily: 'inherit', }}
                                        onClick={() => clearALLState(searchTerm)}
                                    >
                                        Clear
                                    </Button>
                                </>
                            )}

                        </div>
                    </Paper>

                    <Paper className={classes.AutocompletePaperStyle} sx={{ px: 1, py: 0.1, mb: 1, borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                        <Typography style={{ fontSize: '36px', fontWeight: '700', padding: '12px' }}>Leads</Typography>

                        <div style={{ display: 'flex', justifyContent: 'flex-start', margin: '10px', padding: '24px' }}>
                            <div>
                                <Box style={{ display: 'flex', gap: '14px' }}>
                                    <Autocomplete
                                        options={options}
                                        getOptionLabel={(option) => option.label}
                                        renderInput={(params) => <TextField {...params} label="Hours" />}
                                        className={classes.AutoStyle}
                                        value={options.find((option) => option.value === selectedValue) || null}
                                        onChange={HandleChangeHours}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '12px',
                                            },
                                        }}
                                    // disabled={isLoading}
                                    />
                                    <div style={{ marginTop: '-10px' }}>
                                        <div >
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-25px' }}>
                                                <Button
                                                    id="login-button"
                                                    sx={{
                                                        borderRadius: '8px',
                                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                        width: 'auto',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        fontSize: '8px',

                                                    }}
                                                    variant="outlined"
                                                    onClick={handleIsCurrentDate}

                                                >
                                                    Today
                                                </Button>
                                            </div>
                                        </div>
                                        <ThemeProvider theme={theme}>
                                            <GlobalStyles
                                                styles={{
                                                    '::-webkit-scrollbar': {
                                                        width: '14px', // Set the desired width for the scrollbar
                                                    },
                                                    '::-webkit-scrollbar-thumb': {
                                                        backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                                        borderRadius: '10px', // Set the border radius for a rounded effect
                                                    }
                                                }}
                                            />
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DateTimePicker
                                                    sx={{
                                                        marginTop: '10px',
                                                        overflow: 'hidden',
                                                        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#c1c1c1',
                                                        },
                                                        '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#c1c1c1',
                                                        }, '& .MuiOutlinedInput-root': {
                                                            borderRadius: '12px',
                                                        },
                                                    }}
                                                    className={classes.AutoStyle}
                                                    value={isDate}
                                                    onChange={(newDate) => setIsDate(newDate)}
                                                    minDate={dayjs()}
                                                />
                                            </LocalizationProvider>
                                        </ThemeProvider>
                                    </div>
                                    <div>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={isCities}
                                            value={selectedCity}
                                            onChange={(event, value) => setSelectedCity(value)}
                                            className={classes.AutoStyle}
                                            renderInput={(params) => <TextField {...params} label="Cities" />}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                        />
                                    </div>
                                </Box>

                                <Box >
                                    <Typography style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '12px' }}>From now</Typography>
                                    <Button
                                        variant="outlined"
                                        onClick={handleNavigateSchedule}
                                        disabled={!selectedValue || !selectedCity || !isDate}
                                        sx={{
                                            extTransform: 'capitalize', borderRadius: '12px', fontSize: '12px'

                                        }}

                                    >
                                        Show All
                                    </Button>
                                    <Button
                                        style={{
                                            width: 'auto',
                                            height: '30px',
                                            border: '1px solid gray',
                                            background: '#bababa',
                                            borderRadius: '12px',
                                            fontWeight: 'bold',
                                            cursor: 'pointer',
                                            color: 'black',
                                            fontSize: 'auto',
                                            marginLeft: '12px',
                                        }}
                                        disabled={!selectedValue || !selectedCity || !isDate}
                                        onClick={() => HandleClearLocalStorageCityDate()}
                                    >
                                        Clear
                                    </Button>
                                </Box>
                            </div>
                        </div>
                    </Paper>

                    <div
                    >
                        <>
                            <Box style={{ display: 'flex', gap: '5px', padding: '12px' }}>
                                <Button onClick={() => setViewMode('list')}>List View</Button>
                                <Button onClick={() => setViewMode('thumbnail')}>Thumbnail View</Button>
                            </Box>
                            {viewMode === 'list' ? (
                                <>
                                    <div
                                        className={classes.LeadTable}
                                    >
                                        <MaterialReactTable
                                            columns={columns}
                                            data={LeadData}
                                            state={{ isLoading: isLoading }}
                                            muiCircularProgressProps={{
                                                color: 'secondary',
                                                thickness: 5,
                                                size: 55,
                                            }}
                                            muiSkeletonProps={{
                                                animation: 'pulse',
                                                height: 28,
                                            }}
                                            enableTopToolbar={false}
                                            enableFacetedValues={true}
                                            enableStickyHeader={true}
                                            enableDensityToggle={false}
                                            enableHiding={false}
                                            showSkeletons={false}
                                            enableColumnFilterModes={false}
                                            enableColumnActions={false}
                                            enableColumnOrdering={false}
                                            enableFullScreenToggle={false}
                                            enableColumnFilters={false}
                                            enablePagination={false}
                                            getRowId={(row) => row.id}
                                            initialState={{
                                                showColumnFilters: false,
                                                showGlobalFilter: false,
                                            }}
                                            muiTableBodyRowProps={{
                                                sx: {
                                                    backgroundColor: '#f5f5f5', // Default row background color
                                                    '&:nth-of-type(odd)': {
                                                        backgroundColor: '#ffffff', // Alternate rows with white
                                                    },
                                                    '&:hover': {
                                                        backgroundColor: '#e0e0e0', // Hover effect
                                                        cursor: 'pointer'
                                                    },
                                                },
                                            }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <div style={{
                                    display: 'flex', flexWrap: 'wrap',
                                    // justifyContent: 'flex-start', 
                                    marginBottom: '40px',
                                    marginLeft: '12px',
                                    justifyContent: 'center'
                                }}>
                                    {LeadData?.map((lead, index) => {

                                        return (
                                            <>
                                                <ScrollAnimation animateIn='fadeIn'>
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            border: '1px solid #ccc',
                                                            padding: '10px',
                                                            margin: '10px',
                                                            borderRadius: '15px',
                                                            width: '180px',
                                                            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                                            transform: 'scale(1)', // Initial scale
                                                            transition: 'transform 0.3s ease-in-out', // Transition for smooth scaling
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'} // Slight zoom on hover
                                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'} // Revert to original scale
                                                    >
                                                        {/* Customize the thumbnail view here */}

                                                        <Avatar alt={lead?.first_name} src={logo_between} sx={{ mr: 2, width: 80, height: 80 }} />
                                                        <div style={{ display: 'contents', height: '65px', }}>
                                                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{lead?.first_name} {lead?.last_name}</span>
                                                            {/* <span style={{fontSize:'12px', }}>{lead?.email}</span> */}
                                                            <span style={{ fontSize: '10px', fontWeight: '500' }}>{StatusDisplayMap[lead?.status]}</span>
                                                            <span style={{ fontSize: '10px' }}>AssignBy: {lead?.assign_user_leads?.[0]?.assignby?.name} {' '}{lead?.assign_user_leads?.[0]?.assignby?.last_name}</span>
                                                            <span style={{ fontSize: '10px' }}>AssignTo:{lead?.assign_user_leads?.[0]?.assignto?.name}{' '}{lead?.assign_user_leads?.[0]?.assignto?.last_name}</span>
                                                            <span style={{ fontSize: '10px' }}>Appt:{' '}
                                                                {lead?.date && lead?.time && (() => {
                                                                    const dateTimeString = `${lead.date} ${lead.time}`;
                                                                    const dateTime = new Date(dateTimeString);
                                                                    const userOffset = getUserOffset();
                                                                    const adjustedDateTime = adjustTimeBasedOnOffsetForReceivedData(dateTime, userOffset);
                                                                    return formatDateTimeIn12HourFormat(adjustedDateTime);
                                                                })()}
                                                            </span>
                                                        </div>

                                                        <IconButton aria-label="view" onClick={ () => handleNavigateLeadDetails(lead?.id)}>
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </div>
                                                </ScrollAnimation>
                                            </>

                                        )

                                    })}
                                </div>
                            )}
                        </>

                        <Pagination
                            count={totalPages}
                            color="primary"
                            page={currentPage}
                            onChange={(event, value) => setCurrentPage(value)}
                            className={classes.PaginationLeadTable}

                        />
                    </div>
                </div>

                <ScrollAnimation animateIn='fadeIn'>
                    <Grid container spacing={0} sx={{ marginBottom: '30px' }}>
                        <Grid item xs={12} sm={12} md={6} sx={{ marginTop: '40px' }}>
                            <ScrollAnimation animateIn="fadeIn">
                                <Box
                                    height={490}
                                    style={{
                                        background: '#FFFFFF',
                                        borderRadius: '22px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    }}
                                >
                                    <canvas ref={chartRef}></canvas>
                                </Box>
                            </ScrollAnimation>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            sx={{ marginTop: '40px' }}
                        >
                            <Box
                                height={490}
                                sx={{
                                    background: '#FFFFFF',
                                    borderRadius: '22px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    margin: {
                                        md: '0px 20px',
                                    },
                                    marginRight: {
                                        md: '0px'
                                    },
                                    overflowX: 'auto'
                                }}
                            >
                                <h3 style={{ padding: '25px', paddingBottom: '0px', fontSize: '22px', fontWeight: 'bold', color: '#6D6D6D' }}>
                                    Status Overview
                                </h3>
                                <div style={{ padding: '20px' }}>
                                    <Grid container spacing={2}>
                                        {paiChartData?.map((status, index) => {
                                            const statusColor = circleProgressColors[status.status] || 'gray';
                                            const statusLabel = statusLabelColors[status.status] || 'gray';
                                            const statusImage = statusImages[status.status] || null;
                                            return (
                                                <Grid item xs={12} sm={2.4} md={4} lg={3} key={index}>
                                                    <Card
                                                        style={{
                                                            padding: '10px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '18px',
                                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                            textAlign: 'center',
                                                            cursor: 'pointer',
                                                            transform: 'scale(1)',
                                                            transition: 'transform 0.3s ease-in-out',
                                                            background: '#FBFBFB',
                                                        }}
                                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                    >
                                                        <div style={{ display: 'flex' }}>
                                                            <div>
                                                                <Avatar
                                                                    alt="AI"
                                                                    src={statusImage}
                                                                />
                                                            </div>
                                                            <div style={{ width: 100, height: 100, margin: 'auto' }}>
                                                                <CircularProgressbar
                                                                    value={percentages[index]}
                                                                    text={`${percentages[index]}%`}
                                                                    styles={buildStyles({
                                                                        textColor: statusLabel,
                                                                        pathColor: statusColor,
                                                                        textSize: '16px',
                                                                        fontWeight: 'bold',
                                                                        pathTransitionDuration: 0.5,
                                                                    })}
                                                                    strokeWidth={'14'}
                                                                />
                                                            </div>
                                                        </div>
                                                        <Box style={{ display: 'grid', justifyContent: 'flex-start', marginTop: '5px' }}>
                                                            <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                                <Typography style={{ fontSize: '14px', fontWeight: 'bold', color: statusLabel }}>
                                                                    {status.status}
                                                                </Typography>
                                                            </Box>
                                                            <Box style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '5px' }}>
                                                                <div>
                                                                    <Typography style={{ fontSize: '14px', color: '#898484' }}>Number Count:</Typography>
                                                                </div>
                                                                <div style={{ display: 'flex' }}>
                                                                    <Typography style={{ fontSize: '12px', color: '#605e5e', marginLeft: '20px', fontWeight: 'bold' }}>
                                                                        {status.status_count}
                                                                    </Typography>
                                                                </div>
                                                            </Box>
                                                        </Box>
                                                    </Card>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </div>
                            </Box>
                        </Grid>
                    </Grid>
                </ScrollAnimation>
            </ScrollAnimation >
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </>
    );
};

export default AdminLeads;
